// extracted by mini-css-extract-plugin
export default {"selectCss":"customCalendarHeader_selectCss__6deyK"};